export const FAQ = ({ faqNo, faqQstn, faqAnswer, selected, setSelected }) => {
  return (
    <>
      <dl className='mt-6 space-y-6'>
        <div className='pt-6'>
          <dt className='text-lg' onClick={() => setSelected(selected !== faqNo ? faqNo : null)}>
            <button
              type='button'
              className='flex w-full items-start justify-between text-left text-white'
              aria-controls={`faq-${faqNo}`}
              aria-expanded={selected === faqNo}
            >
              <h3 className='3xl:text-2xxl widest text-base font-bold sm:text-2xl'>{faqQstn}</h3>
              <span className='ml-6 flex h-7 items-center'>
                {selected === faqNo ? (
                  <svg
                    width='22'
                    height='14'
                    viewBox='0 0 22 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M20 12L11 3L2 12'
                      stroke='url(#paint0_linear_248_325)'
                      strokeWidth='3'
                    />
                    <defs>
                      <linearGradient
                        id='paint0_linear_248_325'
                        x1='17.7406'
                        y1='3'
                        x2='3.20502'
                        y2='3.00172'
                        gradientUnits='userSpaceOnUse'
                      >
                        <stop stopColor='#5A68E6' />
                        <stop offset='1' stopColor='#4986EA' stopOpacity='0.68' />
                      </linearGradient>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width='22'
                    height='14'
                    viewBox='0 0 22 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M2 2L11 11L20 2'
                      stroke='url(#paint0_linear_248_327)'
                      strokeWidth='3'
                    />
                    <defs>
                      <linearGradient
                        id='paint0_linear_248_327'
                        x1='4.25941'
                        y1='11'
                        x2='18.795'
                        y2='10.9983'
                        gradientUnits='userSpaceOnUse'
                      >
                        <stop stopColor='#5A68E6' />
                        <stop offset='1' stopColor='#4986EA' stopOpacity='0.68' />
                      </linearGradient>
                    </defs>
                  </svg>
                )}
              </span>
            </button>
          </dt>
          <dd
            className='mt-2 pr-12'
            id={`faq-${faqNo}`}
            style={{ display: selected === faqNo ? 'block' : 'none' }}
          >
            <p className='pt-4 text-base font-medium text-white sm:text-xl lg:text-lg'>
              {faqAnswer}
            </p>
          </dd>
        </div>
      </dl>
    </>
  );
};
